interface BirchCalcProps {
  birthStr: string;
  finalDateStr: string;
}

export function birthCalc({ birthStr, finalDateStr }: BirchCalcProps) {
  const birthDate = new Date(birthStr);
  const dateToCompare = new Date(finalDateStr);

  if (!birthStr) return 'sem dados';

  let years = dateToCompare.getFullYear() - birthDate.getFullYear();
  let months = dateToCompare.getMonth() - birthDate.getMonth();
  let days = dateToCompare.getDate() - birthDate.getDate();

  if (months < 0 || (months === 0 && days < 0)) {
    years--;
    months += 12;
  }

  if (days < 0) {
    const lastPrevDay = new Date(
      dateToCompare.getFullYear(),
      dateToCompare.getMonth(),
      0,
    ).getDate();
    days += lastPrevDay;
    months--;
  }

  return `${years} anos, ${months} meses e ${days} dias`;
}
